import React from 'react';
import BulkQuickFixPage from './BulkQuickFixPage';
import { fetchInvalidPartAttributes } from '../../../actions/items/ai_quick_fixes/bulk';
import { INVALID_PART_ATTRIBUTES_ANALYSIS_ID } from '../../../constants/InboxConstants';
import { ApplicationState } from '../../../reducers';

const PartAttributesQuickFixPage: React.FC = () => {
  return (
    <BulkQuickFixPage
      config={{
        analysisId: INVALID_PART_ATTRIBUTES_ANALYSIS_ID,
        fetchAction: fetchInvalidPartAttributes,
        loadingSelector: (state: ApplicationState) =>
          state.items.bulkAIQuickFixes.fetchInvalidPartAttributes,
        dataSelector: (state: ApplicationState) =>
          state.items.bulkAIQuickFixes.invalidPartAttributesData,
        emptyStateDescription: 'quickfix:noInvalidPartAttributes',
        displayMode: 'flat',
      }}
    />
  );
};

export default PartAttributesQuickFixPage;
